import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class AdminLinks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      renderedData: []
    };
  }

  isUrl = (s) => {
    const regexp = /(ftp|http|https):(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(|([\w#!:.?+=&%@!-]))?/;

    return regexp.test(s);
  }

  renderLink = (url, name) => {
    const { handleMenu } = this.props;

    if (this.isUrl(url)) {
      return (<a href={url} target='_blank'>{name}</a>);
    }

    return (<Link key={name} to={url} onClick={() => handleMenu()}>{name}</Link>);
  }

  renderData = () => {
    const { data } = this.state;
    const renderedData = data.map(item => this.renderLink(item.url, item.name));

    this.setState({
      renderedData
    });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.adminLinks !== this.props.adminLinks && Array.isArray(this.props.adminLinks) && !!this.props.adminLinks.length) {
      let { adminLinks } = this.props;

      if (adminLinks.length > 10) {
        adminLinks = adminLinks.slice(0, 10);
      }

      this.setState({
        data: adminLinks.map((article) => {
          const { attributes } = article;

          return {
            name: attributes.name,
            url: attributes.url
          };
        })
      }, () => {
        this.renderData();
      });
    }
  }

  componentDidMount = () => {
    if (Array.isArray(this.props.adminLinks) && !!this.props.adminLinks.length) {
      let { adminLinks } = this.props;

      if (adminLinks.length > 10) {
        adminLinks = adminLinks.slice(0, 10);
      }

      this.setState({
        data: adminLinks.map((article) => {
          const { attributes } = article;

          return {
            name: attributes.name,
            url: attributes.url
          };
        })
      }, () => {
        this.renderData();
      });
    }
  }

  render() {
    const { renderedData } = this.state;

    return (
      renderedData.length > 0 && (
        <div className="nav-menu-links-list nav-menu-admin-links">
          <h4>I NEED HELP...</h4>
          <div className="header-underline" />
          {renderedData.map(item => (
            item
          ))}
        </div>
      )
    );
  }
}

const mapStateToProps = state => ({
  adminLinks: state.adminLinks.links
});

export default connect(mapStateToProps)(AdminLinks);
